import React, { useState, useCallback, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { getTemplateCategories } from "@/components/Joyspace/api/createmenu";
import { Template } from "@/components/Joyspace/types";
import "./index.less";
import Modal from "antd/lib/modal/Modal";
import default_chat_png from "@/assets/img/no-content.png";
import save_to_template from "@/assets/img/save_to_template.png";
import { GlobalContextConfig } from "@/context/GlobalContext";
import { Empty, Tabs, Checkbox, Select } from "antd";
import Loading from "@/components/Loading";
import { changeEgovUrl } from "@/utils/tools";
import IconFont from "@/components/icon";
import { useTranslation } from "../../context";
import { woPng, exPng } from "@/assets/images";
import { analysisLog } from "@/utils/logAnalytics";

const CheckboxGroup = Checkbox.Group;
const { Option } = Select;
const { TabPane } = Tabs;
const style = { margin: 0 };
const TempType = {
  selfDefine: "selfDefine",
  stander: "stander"
};

interface ITState {
  tempItemData: any;
  selfDefine: boolean;
  handleTemplateClick: (id: string, pageType: number) => {};
}
function TempItem(props: ITState) {
  const { tempItemData = {}, handleTemplateClick, selfDefine = false } = props;

  const getIcon = (page_type: number) => {
    return page_type === 1 ? woPng : exPng;
  };
  return (
    <div
      className="temp-item"
      onClick={() => handleTemplateClick(tempItemData.id, tempItemData.page_type)}
    >
      <img
        src={changeEgovUrl(tempItemData.cover_img_url)}
        alt={tempItemData.title}
        className="temp-item-img"
      />
      <div className="temp-item-display">
        <img src={getIcon(tempItemData.page_type)} className="temp-item-icon" />
        <div className="temp-item-title">{tempItemData.title}</div>
      </div>
      <div className="temp-item-name" style={{ fontWeight: "bold" }}>
        使用该模板
      </div>
    </div>
  );
}

interface TState {
  tempData: any;
  selfDefine?: boolean;
  handleTemplateClick: Function;
  pageType: number | "";
}
export function TempContent(props: TState) {
  const { tempData = [], handleTemplateClick, selfDefine = false, pageType } = props;
  const length = tempData.length;
  const description =
    "您可在文档详情页右上角更多操作中，选择“保存为模板”。将重复使用的文档转换为模板，提升编辑效率。";
  let allTempList: any[] = [];
  tempData.forEach((item: any) => {
    if (item.templateList) {
      allTempList = [...allTempList, ...item.templateList];
      item.filterTemplateList = item.templateList;
    }
  });

  let filterAllTempList = [...allTempList];
  if (pageType !== "") {
    filterAllTempList = [...allTempList].filter((item: any) => {
      return item.page_type === pageType;
    });
    tempData.forEach((item: any) => {
      if (item.templateList) {
        item.filterTemplateList = item.templateList.filter((item: any) => {
          return item.page_type === pageType;
        });
      }
    });
  }

  const noData = useMemo(() => {
    if (!selfDefine && length === 0) {
      return (
        <div className="no-data">
          <Empty image={default_chat_png} description="暂无模板" imageStyle={style} />
        </div>
      );
    }
    if (selfDefine && pageType === 4 && length === 0) {
      return (
        <div className="no-data">
          <Empty
            image={default_chat_png}
            description="暂不支持设置个人表格模板"
            imageStyle={style}
          />
        </div>
      );
    }
  }, [length, selfDefine, pageType]);

  return (
    <>
      {/* 只有个人模板的协同表格不显示 全部模板 */}
      {(!selfDefine || pageType !== 4) && (
        <Tabs tabPosition="left" defaultActiveKey="all" className="temp-nav-left">
          <TabPane className="temp-item-pane" tab="全部模板" key="all">
            {!selfDefine && pageType !== "" && (
              <div
                className="temp-item"
                key="all-add"
                onClick={() => handleTemplateClick("", pageType)}
              >
                <div className="temp-item-img add-new">+</div>
                <div className="temp-item-name add-new-name">
                  {pageType === 1 ? "创建空白文档" : "创建空白表格"}
                </div>
                <div className="temp-item-name add-new-hover">
                  {pageType === 1 ? "创建空白文档" : "创建空白表格"}
                </div>
              </div>
            )}
            {selfDefine && pageType !== 4 && filterAllTempList.length === 0 && (
              <div className="selfDefine-no-data">
                <Empty
                  className="save_to_template"
                  image={save_to_template}
                  description={description}
                  imageStyle={{ width: "184px", height: "213px" }}
                />
              </div>
            )}
            {filterAllTempList.map((temp: any, index: number) => {
              return (
                <TempItem
                  selfDefine={selfDefine}
                  key={temp + index}
                  tempItemData={temp}
                  handleTemplateClick={() => handleTemplateClick(temp.id, temp.page_type)}
                />
              );
            })}
          </TabPane>
          {tempData.length > 1 &&
            tempData.map((item: any) => {
              return (
                <TabPane className="temp-item-pane" tab={item.name} key={item.id}>
                  {item.filterTemplateList &&
                    item.filterTemplateList.map((temp: any, index: number) => {
                      return (
                        <TempItem
                          key={temp + index}
                          tempItemData={temp}
                          selfDefine={selfDefine}
                          handleTemplateClick={() => handleTemplateClick(temp.id, temp.page_type)}
                        />
                      );
                    })}
                </TabPane>
              );
            })}
        </Tabs>
      )}
      {noData}
    </>
  );
}

interface FBProps {
  setState: Function;
  pageType: number | "";
  showSheetTemp?: boolean;
}

function FilterButton(props: FBProps) {
  const { pageType, setState, showSheetTemp = true } = props;
  const lang = useTranslation();
  const [visible, setVisible] = useState<boolean>(false);
  const filterOptions = [
    {
      value: "",
      label: lang("template.filterItem.all")
    },
    {
      value: 1,
      label: lang("template.filterItem.document")
    }
  ];

  if (showSheetTemp) {
    filterOptions.push({
      value: 4,
      label: lang("template.filterItem.spreadsheet")
    });
  }

  const onSelect = (value: any) => {
    analysisLog("xtbg_joyspace_templateLib_1688719461025", "2", value === "" ? 0 : value);
    setState((s: IState) => ({
      ...s,
      pageType: value
    }));
  };

  return (
    <Select
      open={visible}
      defaultValue={pageType}
      dropdownMatchSelectWidth={false}
      getPopupContainer={(triggerNode) => triggerNode.parentElement || document.body}
      onClick={() => setVisible(!visible)}
      onBlur={() => setVisible(false)}
      onSelect={onSelect}
      className="template-filter-select"
      dropdownClassName="template-filter-dropdown"
      suffixIcon={
        <IconFont
          type="icona-ic_pc_im_screen"
          style={{
            color: "rgba(0, 0, 0, 0.65)",
            transform: "rotateY(180deg)",
            pointerEvents: "none"
          }}
        />
      }
    >
      {filterOptions.map((item: any) => {
        return (
          <Option key={item.value} value={item.value}>
            {item.label}
          </Option>
        );
      })}
    </Select>
  );
}

interface IProps {
  globalContext: GlobalContextConfig;
  onClose?: () => void;
  callback: (id: string, pageType: number) => void;
  pageType?: number | "";
  focusToken?: String;
  title?: string;
  isJoyspace?: boolean;
  canCreateSheet?: boolean;
}
interface IState {
  selectTemplateId: string;
  selectTemplate: Template | null;
  categories: null;
  visible: boolean;
  pageType: number | "";
  isloading: boolean;
}

export function CreateByTemplate(props: IProps) {
  const { onClose, callback, title, isJoyspace = false, canCreateSheet = true } = props;
  const [state, setState] = useState<IState>({
    visible: true,
    selectTemplateId: "",
    categories: null,
    pageType: props.pageType || "",
    selectTemplate: null,
    isloading: true
  });

  useEffect(() => {
    setState((s: IState) => ({
      ...s,
      isloading: true
    }));
    getTemplateCategories(state.pageType)
      .then((data) => {
        if (data) {
          setState((s: IState) => ({
            ...s,
            categories: data,
            isloading: false
          }));
        }
      })
      .catch(() => {
        const data = {
          selfDefine: [],
          stander: []
        };
        // @ts-ignore
        setState((s: IState) => ({
          ...s,
          categories: data,
          isloading: false
        }));
      });
  }, [state.pageType]);
  const handleTemplateClick = (id: string, pageType: number) => {
    setState((s: IState) => ({
      ...s,
      visible: false
    }));
    callback?.(id, pageType);
  };
  const handleCancel = () => {
    setState((s: IState) => ({
      ...s,
      visible: false
    }));
    onClose?.();
  };
  const { categories, visible, isloading } = state;
  return (
    <Modal
      visible={visible}
      className="joyspace-create-template-modal"
      width={760}
      onCancel={handleCancel}
      cancelText="取消"
      title={title ? title : "选择模板"}
      footer={null}
    >
      <Tabs
        defaultActiveKey={TempType.stander}
        className="template-list-nav"
        tabBarExtraContent={
          isJoyspace ? (
            <FilterButton
              setState={setState}
              pageType={state.pageType}
              showSheetTemp={canCreateSheet}
            />
          ) : null
        }
      >
        <TabPane className="template-list-tab-pane" tab="推荐模板" key={TempType.stander}>
          {!isloading && (
            <TempContent
              handleTemplateClick={handleTemplateClick}
              tempData={(categories as any)[TempType.stander]}
              pageType={state.pageType}
            />
          )}
          {isloading && (
            <div className="loading">
              <Loading />
            </div>
          )}
        </TabPane>
        <TabPane className="template-list-tab-pane" tab="个人模板" key={TempType.selfDefine}>
          {!isloading && (
            <TempContent
              handleTemplateClick={handleTemplateClick}
              selfDefine={true}
              tempData={(categories as any)[TempType.selfDefine]}
              pageType={state.pageType}
            />
          )}
          {isloading && (
            <div className="loading">
              <Loading />
            </div>
          )}
        </TabPane>
      </Tabs>
    </Modal>
  );
}

export default function openTemplateModal(props: IProps) {
  const { globalContext } = props;
  const { authInfo } = globalContext;
  // service.authService.exchangeWebToken().then((res) => {
  const focusToken = authInfo?.accessToken;
  const ele = document.createElement("div");
  document.body.appendChild(ele);
  function onClose() {
    if (ele) {
      ReactDOM.unmountComponentAtNode(ele);
      ele.remove();
    }
  }
  ReactDOM.render(<CreateByTemplate {...{ ...props, focusToken, onClose }} />, ele);
  // });
}
